import { SocietyProfileInvoiceInvoiceItemDiscountCodeParamsInput } from "shared/api/types/society/[societyId]/profiles/[profileId]/accounting/invoice/[invoiceId]/item/[invoiceItemId]/discountCode/[discountCodeString]";
import { InvoiceView } from "shared/mappers/database/accounting/invoice/invoice";
import { BaseApiContract } from "shared/api/apiRequestContractHandler";
import { HttpMethod } from "shared/api/http";
export const postSocietyProfileAccountingInvoiceItemDiscountCodeStringContract: BaseApiContract<
  SocietyProfileInvoiceInvoiceItemDiscountCodeParamsInput,
  undefined,
  InvoiceView
> = {
  method: HttpMethod.POST,
  apiRoute:
    "/api/v1/society/[societyId]/profiles/[profileId]/accounting/invoice/[invoiceId]/item/[invoiceItemId]/discountCode/[discountCodeString]",
  paramsType: {} as SocietyProfileInvoiceInvoiceItemDiscountCodeParamsInput,
  responseType: {} as InvoiceView,
};
